import React from "react";
import {
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { ZIP_CODES } from "components/dashboard/zipSlotAds/zipCodes";
import { BID_STATUS } from "./zipSlotAdsConstants";
import { formatCents } from "./zipSlotAdsHelpers";

const ZipSlotSelectedTable = ({
  selectedZips,
  focusedZip,
  onFocusZip,
  ownBidsByZip = {},
  ownRankByZip = {},
}) => {
  const zips = Array.from(selectedZips || []);
  if (zips.length === 0) return null;

  return (
    <TableContainer component={Paper} sx={{ mb: 3 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ZIP code</TableCell>
            <TableCell>Your rank</TableCell>
            <TableCell>Your bid</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {zips.map((zip) => {
            const zipData = ZIP_CODES[zip];
            const ownBid = ownBidsByZip[zip];
            const rank = ownRankByZip[zip];
            const selected = focusedZip === zip;
            return (
              <TableRow
                key={zip}
                hover
                selected={selected}
                onClick={() => onFocusZip(zip)}
                sx={{ cursor: "pointer" }}
              >
                <TableCell>
                  <Typography variant="body1" fontWeight="bold">
                    {zip}
                  </Typography>
                  {zipData?.city || zipData?.state ? (
                    <Typography variant="body2" color="text.secondary">
                      {[zipData.city, zipData.state].filter(Boolean).join(", ")}
                    </Typography>
                  ) : null}
                </TableCell>
                <TableCell>
                  {rank ? `#${rank}` : ownBid ? "Not in top 7" : "—"}
                </TableCell>
                <TableCell>
                  {ownBid?.bidPerClickCents != null
                    ? formatCents(ownBid.bidPerClickCents)
                    : "—"}
                </TableCell>
                <TableCell>
                  {ownBid?.status === BID_STATUS.ACTIVE ? (
                    <Chip size="small" color="success" label="Active" />
                  ) : ownBid?.status === BID_STATUS.INSUFFICIENT_BALANCE ? (
                    <Chip size="small" color="warning" label="Low balance" />
                  ) : ownBid?.status === BID_STATUS.INELIGIBLE ? (
                    <Chip size="small" label="Ineligible" />
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      No bid
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ZipSlotSelectedTable;
